<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content" v-if="tag == 'verifiedlaserno'">
                <div class="bg-white w-full rounded-xl p-3">
                    <div class="text-center text-lg pb-5 pt-3">
                        <div class="pb-3.5 border-b border-gray-2">
                            <div class="flex pb-2">
                                <img class="m-auto" src="@/assets/icon/ic-confirm.png" alt="" />
                            </div>
                            <div class="pt-3 text-22 text-gray-1" v-html="message"></div>
                        </div>
                    </div>
                    <div class="pb-6">
                        <button class="w-full bg-green-1 text-22 text-white rounded-r-full rounded-l-full py-2.5" @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
                <div class="flex absolute -bottom-5 left-0 w-full">
                    <img class="w-10 h-10 m-auto" @click="clickCancel()" src="@/assets/icon/ic-close.svg" alt="" />
                </div>
            </div>

            <div class="modal-content" v-else>
                <div class="bg-white w-full rounded-xl p-3">
                    <div class="text-center text-lg pb-5 pt-3">
                        <div class="pb-3.5 border-b border-gray-2">
                            <div class="text-center text-30 text-blue-1 pt-3" v-html="title"></div>
                            <div class="pt-3 text-22 text-gray-1" v-html="message"></div>
                        </div>
                    </div>
                    <div class="pb-6">
                        <button class="w-full bg-green-1 text-22 text-white rounded-r-full rounded-l-full py-2.5" @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
                <div class="flex absolute -bottom-5 left-0 w-full">
                    <img class="w-10 h-10 m-auto" @click="clickCancel()" src="@/assets/icon/ic-close.svg" alt="" />
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ConfirmModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            tag: '',
            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.tag = config.tag;
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        .modal-content {
            overflow: unset;
            width: 100%;
            max-width: 414px;
            padding: 0 16px;
        }
    }
</style>
